import { css } from 'styled-components'

export const RectangleNetworkBackgroundGradient = `repeating-linear-gradient(
      0deg,
      rgba(var(--background-2-rgb), 0.5),
      rgba(var(--background-2-rgb), 0.5) 1px,
      transparent 1px,
      transparent 10px
    ),
    repeating-linear-gradient(
      90deg,
      rgba(var(--background-2-rgb), 0.5),
      rgba(var(--background-2-rgb), 0.5) 1px,
      transparent 1px,
      transparent 10px
    )`
export const RectangleNetworkBackground_ = css`
  background-image: ${RectangleNetworkBackgroundGradient};
`
export const RectangleNetworkBackground = css`
  ${RectangleNetworkBackground_}
  background-color: var(--appearance-1);
`

export const RectangleNetworkBackground60 = css`
  ${RectangleNetworkBackground_}
  background-color: var(--appearanceA-6);
`
